export const CartConfirmationOutcome = {
  Wait: 'wait',
  OpenCartModal: 'open-cart-modal',
  Confirm: 'confirm',
  Redirect: 'redirect',
} as const;

export type CartConfirmationOutcome = (typeof CartConfirmationOutcome)[keyof typeof CartConfirmationOutcome];

interface Params {
  isLoading: boolean;
  isReady: boolean;
  hasErrors: boolean;
  isModalOpened: boolean;
  hasCouponErrors: boolean;
}

export function resolveCartConfirmationOutcome({
  isLoading,
  isReady,
  hasErrors,
  isModalOpened,
  hasCouponErrors,
}: Params): CartConfirmationOutcome {
  if (isLoading) return CartConfirmationOutcome.Wait;
  if (hasErrors && !isModalOpened) return CartConfirmationOutcome.OpenCartModal;
  if (isReady) return CartConfirmationOutcome.Confirm;
  if (!hasCouponErrors) return CartConfirmationOutcome.Redirect;

  return CartConfirmationOutcome.Wait;
}
